import React, { useEffect, useState } from 'react';

import Modal from '@components/common/Modal';
import EditChangesModal
	from '@components/routes/AdminPanel/ManageNetworkElementConfigurations/ChangeMonitoring/EditChanges/EditChangesModal';

import {
	useQueryChangesMonitoringUpdateString,
} from '@hooks/networkElementConfigurations/useQueryChangesMonitoringUpdateString';

import { IChangeMonitoring } from '@interfaces/networkElementConfigurations/networkElementConfigurations';
import { TMapTree } from '@components/common/FlatXMLTree/interface';

import { MODAL_WIDTH_880 } from '@constants/modals';

export default function EditChanges({
	onClose,
	networkElement,
}: {
	onClose: () => void;
	networkElement: IChangeMonitoring;
}) {
	const [isDirtyForm, setIsDirtyForm] = useState(false);
	const [changedIds, setChangedIds] = React.useState<string[]>([]);
	const [treeData, setTreeData] = useState<TMapTree>(new Map());

	const {
		isUpdateStringLoading,
		data,
	} = useQueryChangesMonitoringUpdateString({
		id: networkElement.id,
	});

	useEffect(() => {
		if (data?.tree) {
			setTreeData(data?.tree);
		}
	}, [data?.tree]);

	useEffect(() => {
		setIsDirtyForm(!!changedIds.length);
	}, [changedIds, setIsDirtyForm]);

	return data ? (
		<Modal
			height='85vh'
			isConfirmDialogNeededOnClose
			isDirtyForm={isDirtyForm}
			isLoading={isUpdateStringLoading}
			isOpen
			onClose={onClose}
			title='Edit parameter'
			width={MODAL_WIDTH_880}
		>
			<EditChangesModal
				changedIds={changedIds}
				closeModal={onClose}
				data={treeData}
				folderId={data?.validationRulesFolderId}
				isReadOnly={false}
				onClose={onClose}
				setChangedNodeIds={setChangedIds}
				setData={setTreeData}
				updateId={networkElement.id}
				withSearch={false}
			/>
		</Modal>
	) : null;
}
